<template>
    <div>
        <div id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta pagina.
            </p>
        </div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="card-title-style"> Redirect </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
export default {
    props: ["tokenData"],
    data() {
        return {
            validForm: true,
            respuestaText: "SI",
            encabezadoText: [],
            loaded: false,

            dateCollabsable: false,
            dateComponentConstraints: {},


        };
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    mounted() {

        this.getDatosGenerales();
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),

        async getDatosGenerales() {

            var str = this.tokenData.toString();
            var subs = str.split('-');
            var dataArray = [];
            if (subs.length == 1) {
                let result = await SerBusqueda.Desencriptar(this, subs[0])
                dataArray = result;

                if (dataArray.vista == "DetalleUsuario") {
                    await MetodosGenerales.guardarEnSesionInfoReporte(dataArray, 'DetalleUsuarioBusqueda');
                } else if (dataArray.vista == "DetallePreUsuario") {
                    await MetodosGenerales.guardarEnSesionInfoReporte(dataArray, 'preusr');
                } else if (dataArray.vista == "AltaUsuario") {
                    await MetodosGenerales.guardarEnSesionInfoReporte(dataArray, 'AltaUsuario');
                }
                else {
                    await MetodosGenerales.guardarEnSesionInfoReporte(dataArray, 'reporte');
                }

                //this.$router.push({ path: this.asistenciaurl + '/Reporte/Citas' });
                if (dataArray.vista != null) {
                    this.$router.push({ name: `${String(dataArray.vista)}` });
                } else {
                    this.$router.push({ name: `${'Whatsapp'}` });
                }
            }
            else if (subs.length == 2) {
                await SerBusqueda.DesencriptarV2(this, subs[0]).then(data => {
                    dataArray = data;
                });
                await MetodosGenerales.guardarEnSesionInfoReporte(dataArray, 'reporte');

                if (dataArray.vista != null) {
                    this.$router.push({ name: `${String(dataArray.vista)}` });
                } else {
                    this.$router.push({ name: `${'Whatsapp'}` });
                }
            }
            else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        }

        /* http://localhost:60316/Redirect/PirunQ*KhYGHO0YExLwRpwY2ANAwBRQJQG9b1mFJcB3onFYfTdmE2J ToXyYtGTn80Yj1nTu3l6*4ejpwrcnLRSWu7F0rbIgGfUV*sMeptM= */

    },
    watch: {

    },
};
</script>
<style></style>
<style scoped></style>
